import { ModelConceptClass } from 'src/containers/ProjectDiagram/types/data';
import { Model } from 'src/containers/ProjectDiagram/types/model';
import { getConnectedHierarchyDataForClass } from 'src/containers/ProjectDiagram/utils/modelConceptHierarchy/getConnectedHierarchyDataForClass';
import { removeModelConceptHierarchy } from 'src/containers/ProjectDiagram/utils/modelConceptHierarchy/removeModelConceptHierarchy';

export const removeAllHierarchiesFromModelConceptClass =
  (data: ModelConceptClass) => (model: Model) => {
    const hierarchyDataArray = getConnectedHierarchyDataForClass(
      model,
      data.value
    );
    hierarchyDataArray.forEach((hierarchyData) => {
      removeModelConceptHierarchy(hierarchyData)(model);
    });
  };
